import { render } from "./Evaluation_of_external_factors.vue?vue&type=template&id=bf4a22e8&scoped=true"
import script from "./Evaluation_of_external_factors.vue?vue&type=script&lang=js"
export * from "./Evaluation_of_external_factors.vue?vue&type=script&lang=js"

import "./Evaluation_of_external_factors.vue?vue&type=style&index=0&id=bf4a22e8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf4a22e8"]])

export default __exports__